import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import TranslateApp from './components/TranslateApp';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/translateapp" element={<TranslateApp />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
    </Routes>
  );
}

export default App;
